import { useDeleteColor } from "http-hooks/color/useColor";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteColor({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteColor();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Color"
      description="Are you sure you want to delete this Color? This Color will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
